module.exports = __webpack_public_path__ + "static/media/img_3-9a.1c22f141.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/c-4/img_3-9a.png
// module id = 661
// module chunks = 0